import React, { Component } from 'react'

import Font from '../atoms/Font'
import Button from '../atoms/Button'
import Loading from '../atoms/Loading'
import { Col } from '../atoms/Grid'
import FlexAlign from '../atoms/FlexAlign'

import T from '../translate/T'

import { myInscriptions } from '../utils'
import { Config } from '../_config.js'

import style from './style.css'
export default class MyInscriptions extends Component {
    state = {
        loading: true,
        data: []
    }

    componentWillMount() {
        myInscriptions()
        .then(resp => {
            this.setState({
                loading: false,
                data: resp
            })
        })
    }
    render() {
        return (
            <div>
                <Font heading="3" style={{textAlign: 'center'}}>{T.text('my_inscriptions')}</Font>
                { this.state.loading && (
                    <Loading style={{padding:'60px'}} />
                )}
                { !this.state.loading && (
                    <ul className={style.list_inscriptions} style={{ marginTop: '30px' }}>
                        { this.state.data.map( item => (
                            <li key={item.token}>
                                <FlexAlign>
                                    <Col size={8}>
                                        <span className={style.event_title}>
                                            {item.event}
                                        </span>
                                    </Col>
                                    <Col size={4}>
                                        <span className={style.payment}>
                                            <a target="_blanck" href={Config.uriCheckout+item.token}>
                                                <Button color="orange">{T.text('view_inscription')}</Button>
                                            </a>
                                        </span>
                                    </Col>
                                </FlexAlign>
                            </li>
                        )) }
                    </ul>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/MyInscriptions/index.js